import React from "react";
import { createColumnHelper } from "@tanstack/react-table";
import { turndropType } from "app/data/static-load/model";
import XGSInlineSwitch from "ui-components/xgs-inline-switch/xgsInlineSwitch";
import XGSInput from "ui-components/xgs-input/xgsInput";
import { useState } from "react";
import { ReactComponent as DeleteIcon } from "images/trash.svg";


const columnHelper = createColumnHelper<any>();

const EditableCell = ({ initialValue, onSubmit, onCancel }: { initialValue: string; onSubmit: (value: string) => void; onCancel: () => void }) => {
  const [inputValue, setInputValue] = useState<string>(initialValue);

  return (
    <XGSInlineSwitch
      name={`cell-${initialValue}`} // or use a unique identifier
      staticContent={<span>{initialValue || "-"}</span>}
      formElement={
        <XGSInput
          value={inputValue}
          onChange={(e) => setInputValue(e.currentTarget.value)}
          disabled={false}
        />
      }
      onCancel={() => {
        setInputValue(initialValue);
        onCancel();
      }}
      onSubmit={() => {
        onSubmit(inputValue);
      }}
      disabled={false}
    />
  );
};

export const getColumnsForDrops = (terminalMap: any, isEditMode: boolean, onSubmit: (value: string, dropId: string, type: "tractorNumber" | "earlyArrivalTime" | "earlyDepartureTime") => void, handleDeleteDrop: (dropId: string) => void) => [
  columnHelper.accessor("dropType", {
    header: "Type",
    size: 100,
    cell: info => info.getValue() ? <div>{turndropType.find(item => item.value === info.getValue())?.label}</div> : '-',
  }),


  columnHelper.accessor("terminalNumber", {
    header: "Terminal Number",
    size: 90,
    cell: info => info.getValue() ? <div>{info.getValue()}</div> : '-',
  }),


  columnHelper.accessor("terminal", {
    header: "Terminal",
    size: 150,
    cell: (cellProps) => {
      return terminalMap[cellProps.row.original.terminalNumber?.toString() || ""] || "-"
    },
  }),


  columnHelper.accessor("miles", {
    header: "Miles",
    size: 90,
    cell: info => info.getValue() ? <div>{info.getValue()}</div> : '-'
  }),

  columnHelper.accessor("earlyArrivalTime", {
    header: "Est. Arrival",
    size: 170,
    cell: (info) => {
      if (isEditMode) {
        const initialValue = info.getValue(); // Get the cell value

        return (
          <EditableCell
            initialValue={initialValue}
            onCancel={() => { }}
            onSubmit={(value) => {
              onSubmit(value, info.row.original.id, "earlyArrivalTime");
            }}
          />
        );
      }
      return <div>{info.getValue() ?? '-'}</div>;
    }

  }),
  columnHelper.accessor("earlyDepartureTime", {
    header: "Est. Departure",
    size: 170,
    cell: (info) => {
      if (isEditMode) {
        const initialValue = info.getValue(); // Get the cell value

        return (
          <EditableCell
            initialValue={initialValue}
            onCancel={() => { }}
            onSubmit={(value) => {
              onSubmit(value, info.row.original.id, "earlyDepartureTime");
            }}
          />
        );
      }
      return <div>{info.getValue() ?? '-'}</div>;
    }

  }),
  columnHelper.accessor("tractorNumber", {
    header: "Tractor",
    size: 170,
    cell: (info) => {
      if (isEditMode) {
        const initialValue = info.getValue(); // Get the cell value

        return (
          <EditableCell
            initialValue={initialValue}
            onCancel={() => { }}
            onSubmit={(value) => {
              onSubmit(value, info.row.original.id, "tractorNumber");
            }}
          />
        );
      }
      return <div>{info.getValue() ?? '-'}</div>;
    }

  }),
  columnHelper.accessor("action", {
    header: "Action",
    size: 90,
    cell: (info) => <div onClick={() => handleDeleteDrop(info.row.original.id)}><DeleteIcon className="clone-week-btn__delete_icon" /></div>
  }),

];
